import { useIsPeopleUnlockButtonLoading } from '@aibees/elephant/components/people-unlock/hooks/use-is-people-unlock-button-loading';
import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import {
  ProcessingItemState,
  useActionButtonContext,
} from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { useContactDetailsState } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/context';
import { profileDetailsLatestUpdateDate } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/utils';

export function useContactDetailsEnrichmentDescriptionText(
  data?: PeopleTableInfo
) {
  const { loadingContactDetails } = useIsPeopleUnlockButtonLoading(data);
  const { unlocked } = useContactDetailsState();

  const { getItemState } = useActionButtonContext();
  const emailEnrichmentProcessState = getItemState({
    id: data?.id || '',
    type: QUICK_INFO_BUTTONS.CONTACT_ENRICHMENT,
  }) as ProcessingItemState.UNLOCKING | ProcessingItemState.UPDATING;

  const desc = {
    [ProcessingItemState.UNLOCKING]: 'Unlocking...',
    [ProcessingItemState.UPDATING]: 'Updating...',
  };

  const loadingText =
    desc[emailEnrichmentProcessState ?? ProcessingItemState.UNLOCKING];

  return loadingContactDetails
    ? loadingText
    : unlocked
    ? `Last Update ${profileDetailsLatestUpdateDate(data)}`
    : 'Unlock to Reveal All Profile Insights';
}
